export const HttpStatus = Object.freeze({
    BadRequest: 400,
    Unauthorized: 401,
    Forbidden: 403,
    NotFound: 404,
    Conflict: 409,
    ServiceUnavailable: 503
});
